import { GetStaticProps } from "next";
import Head from "next/head";
import { MainLayout } from "../components/layouts/MainLayout";
import DesignTinkersService from "../services/DesignTinkersService";
import { PrivacyPolicy } from "../types/PrivacyPolicy";

interface PrivacyPolicyProps {
  data: PrivacyPolicy;
}

const PrivacyPolicy = ({ data }: PrivacyPolicyProps) => {
  return (
    <MainLayout pageTitle={data.title}>
      <Head>
        <title>{data.title}</title>
      </Head>
      <div className="container px-5">
        <div className="my-10 content md:my-14">
          <div
            className="text-base text-gray-800"
            dangerouslySetInnerHTML={{ __html: data.content }}
          ></div>
        </div>
      </div>
    </MainLayout>
  );
};

export default PrivacyPolicy;

export const getStaticProps: GetStaticProps = async (context) => {
  const resp = await DesignTinkersService.getPrivacyPolicy();

  return {
    props: {
      data: resp.data,
    },
  };
};
